<template>
  <header class="py-3 pt-6 header mt-0 lg:mt-6">
    <div
      class="container-1200 flex gap-4 justify-between items-start lg:items-center"
    >
      <div class="w-16 hidden lg:block">&nbsp;</div>
      <div class="flex gap-4 items-center">
        <div class="text-lg lg:text-2xl">Introducing</div>
        <img class="h-6 lg:h-8" src="/logos/logo-evangelist.svg" />
      </div>
      <div class="w-16 text-right">
        <SigninButton class="text-purple hover:underline">
          Log In
        </SigninButton>
      </div>
    </div>
  </header>
</template>
